"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Label = exports.Label = _styledComponents["default"].span.withConfig({
  displayName: "Label",
  componentId: "sc-1sbwovc-0"
})(["color:", ";padding-inline:", " ", ";min-inline-size:0;overflow-wrap:break-word;input:disabled ~ &&{cursor:", ";opacity:", ";}"], (0, _index.cssColorValue)(_index.semanticColors.textBase), (0, _index.cssSpacing)('tighter', '12px'), (0, _index.cssSpacing)('looser', '24px'), _index.cursorDisabled, _index.opacityDisabled);